import {useState} from 'react'

/** Returns the previous distinct value — differs from `usePrevious` which tracks every render. */
export function usePreviousValue<T>(current: T): T | null {
  const [{lastCurrent, previous}, setPrevious] = useState<{
    lastCurrent: T | null
    previous: T | null
  }>({
    lastCurrent: null,
    previous: null
  })

  if (current !== lastCurrent) {
    setPrevious({
      lastCurrent: current,
      previous: lastCurrent
    })
  }
  return previous
}
